var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mainFields.form?.value)?_c('div',{class:{ 'container': _vm.useContainer }},[_c('div',{staticClass:"center",style:({
      'padding-top': _vm.paddingTop + 'px',
      'padding-bottom': _vm.paddingBottom + 'px'
    })},[_c('button',{staticClass:"btn btn--long btn--full",on:{"click":function($event){return _vm.openModal()}}},[_vm._v("\n      "+_vm._s(_vm.mainFields.title?.value)+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }